import { Checkbox, Col, Row, TimePicker } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

let defaultState = [
    { day: "Monday", dayChecked: false, time: null, closed: false, fullDay: false },
    { day: "Tuesday", dayChecked: false, time: null, closed: false, fullDay: false },
    { day: "Wednesday", dayChecked: false, time: null, closed: false, fullDay: false },
    { day: "Thursday", dayChecked: false, time: null, closed: false, fullDay: false },
    { day: "Friday", dayChecked: false, time: null, closed: false, fullDay: false },
    { day: "Saturday", dayChecked: false, time: null, closed: false, fullDay: false },
    { day: "Sunday", dayChecked: false, time: null, closed: false, fullDay: false },
]

const CustomDayPicker = ({ value, onChange, updatedRecord, customFieldReset, setCustomFieldReset }) => {

    const [state, setState] = useState([
        { day: "Monday", dayChecked: false, time: null, closed: false, fullDay: false },
        { day: "Tuesday", dayChecked: false, time: null, closed: false, fullDay: false },
        { day: "Wednesday", dayChecked: false, time: null, closed: false, fullDay: false },
        { day: "Thursday", dayChecked: false, time: null, closed: false, fullDay: false },
        { day: "Friday", dayChecked: false, time: null, closed: false, fullDay: false },
        { day: "Saturday", dayChecked: false, time: null, closed: false, fullDay: false },
        { day: "Sunday", dayChecked: false, time: null, closed: false, fullDay: false },
    ]);

    useEffect(() => {
        if (value?.length > 0) {
            const predefinedDays = [...state]; // Copy the current state
            value.forEach((day) => {
                const index = predefinedDays.findIndex(item => item.day === day.day);
                if (index !== -1) {
                    predefinedDays[index] = {
                        ...predefinedDays[index],
                        dayChecked: day.dayChecked ?? true, // Use provided dayChecked
                        closed: day.closed,
                        fullDay: day.fullDay,
                        time: day.startTime ? [dayjs(day.startTime, 'HH:mm'), dayjs(day.endTime, 'HH:mm')] : null,
                    };
                }
            });
            console.log(predefinedDays)
            setState(predefinedDays);
        }
    }, [value]);


    useEffect(() => {
        if (customFieldReset) {
            setState(defaultState)
            setCustomFieldReset({ ...customFieldReset, time: false })
        }
    }, [customFieldReset == true])

    const updateState = (index, updatedItem) => {
        const newState = state.map((item, idx) => (idx === index ? updatedItem : item));
        setState(newState);

        // Format the time for the onChange callback
        const formattedState = newState.map(item => {
            // if (!item?.dayChecked && item?.time == null && !item?.dayChecked && !item?.closed && !item?.fullDay) {
            //     return
            // }
            return (
                {
                    ...item,
                    startTime: item.time && Array.isArray(item.time) && item.time.length === 2
                        ? item.time[0].format('HH:mm')
                        : null,
                    endTime: item.time && Array.isArray(item.time) && item.time.length === 2
                        ? item.time[1].format('HH:mm') : null
                }
            )
        })?.filter(item => item !== undefined)
        onChange(formattedState); // Call onChange with the updated state
        const updated = formattedState?.find(item => item?.day === updatedItem?.day)
        updatedRecord(updated)
    };

    const timeChangeHandler = (time, timeStrings, index) => {
        const updatedItem = {
            ...state[index],
            time: time ? [dayjs(timeStrings[0], 'HH:mm'), dayjs(timeStrings[1], 'HH:mm')] : null,
        };
        updateState(index, updatedItem);
    };

    const dayCheckHandler = (checked, index) => {
        const updatedItem = {
            ...state[index],
            dayChecked: checked,
        };
        updateState(index, updatedItem);
    };

    const shiftCloseHandler = (checked, index) => {
        const updatedItem = {
            ...state[index],
            time: null,
            closed: checked,
        };
        updateState(index, updatedItem);
    };

    const fullDayHandler = (checked, index) => {
        const updatedItem = {
            ...state[index],
            time: null,
            fullDay: checked,
        };
        updateState(index, updatedItem);
    }

    return (
        <div className='w-full mt-2'>
            {state.map((item, index) => (
                <Row className='flex items-start md:items-center justify-start md:justify-between mb-3 w-full gap-3 md:gap-0 flex-wrap py-2' key={index} gutter={[16]}>
                    <Row className='w-full flex items-center justify-between px-2 py-3'>
                        <Col lg={7} md={7} sm={6} xs={6}>
                            <Checkbox
                                checked={item.dayChecked}
                                onChange={(e) => dayCheckHandler(e.target.checked, index)}
                                className='week-schedule-checkboxes'
                            >
                                {item.day}
                            </Checkbox>
                        </Col>
                        <Col lg={7} md={7} sm={6} xs={6}>
                            <Checkbox
                                checked={item.fullDay}
                                onChange={(e) => fullDayHandler(e.target.checked, index)}
                                className='week-schedule-checkboxes'
                            >
                                24 Hours
                            </Checkbox>
                        </Col>
                        <Col lg={7} md={7} sm={6} xs={6} className='flex md:justify-end justify-start'>
                            <Checkbox
                                checked={item.closed}
                                onChange={(e) => shiftCloseHandler(e.target.checked, index)}
                                className='week-schedule-checkboxes'
                            >
                                Closed
                            </Checkbox>
                        </Col>
                    </Row>
                    <Col lg={24} md={24} sm={24} xs={24} className=''>
                        <TimePicker.RangePicker
                            value={item.time ? [item.time[0], item.time[1]] : null}
                            use12Hours
                            format={'HH:mm A'}
                            disabled={item?.closed || item?.fullDay}
                            // onChange={(time, timeStrings) => timeChangeHandler(time, timeStrings, index)}
                            onChange={(time, timeStrings) => {
                                if (!time) {
                                    // Handle the case where the time picker is cleared
                                    timeChangeHandler(null, [], index);
                                } else {
                                    timeChangeHandler(time, timeStrings, index);
                                }
                            }}
                            className='w-full'
                            allowClear={false}  // This ensures that the clear icon is shown                            
                        />
                    </Col>
                </Row>
            ))}
        </div>
    );
};

export default CustomDayPicker;
